import React, {Component} from 'react'
import PropTypes from "prop-types";
import '../../components_style/rtl_css/FormElementContainer.css'
import '../../components_style/FormElementContainer.css'
import SvGraphics from "../../assets/SvGraphics";

class FormElementContainerExpanded extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }


    render() {
        let {isExpanded} = this.state
        let {title, Component, rest, isSub, SubTitle} = this.props
        return (
            <div className={'patientForm-box-container'}>
                {title !== '' ?
                    <div className={'patientsFormBoxes-title-text'}>
                        <label className={'patientsFormBoxes-title-text-label'}>   {title}</label>
                        <a style={{marginRight: "20px", fontSize: '16px', marginLeft: '20px'}}
                           href={'https://www.sade.group/he/documents/'} target={"_blank"}>{SubTitle}</a>
                    </div>
                    : ""}
                <Component {...rest} />
            </div>

        )
    }
}

FormElementContainerExpanded.propTypes = {
    title: PropTypes.string.isRequired,
    Component: PropTypes.elementType.isRequired,
    rest: PropTypes.object
};

export default FormElementContainerExpanded;
